import React, { Component, PureComponent } from "react";
import { delayTime, REESES_CAMPAIGN, STRIPE_PK } from "../../util/config/Constants";
import { connect } from "react-redux";
import Cookies from 'universal-cookie';
import Fingerprint from 'fingerprintjs'
import { getOffer, markCodeRedeemed, updateInventory, updateVBPInner } from "../../actions/RandomizerAction";
import "./Offer.css";
import Footer from "../footer/Footer";
import { trackVote } from "../../actions/TrackingActions";
import { clearSession, getUrlWord, isSessionActive, showEmbedFooter } from '../../util/helpers/Helpers';
import SpinWheel from "../../components/SpinWheel";
import { OFFER_TYPE } from "../../util/config/app-config";
import timer_image from "../../assets/images/timer.png";
// import Checkout from "./Checkout";

// import { Elements } from "@stripe/react-stripe-js";
// import stripePromise from "./stripe";
import { loadStripe } from "@stripe/stripe-js";
// import CheckoutForm from "./CheckoutForm";
import Checkout from "./Checkout";
import { BEIN_CAMPAIGN, BEIN_SPL_OFFER } from "../../util/config/Constants";
import content_copy from './../../assets/images/content_copy.png';
import TimerView from "./TimerView";
// console.log('render Elements stripePromise:', stripePromise);
export class Offer extends PureComponent {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.redeem = this.redeem.bind(this);
    this.state = {
      delayTime: delayTime,
      showBtn: false,
      hash: '',
      spinComplete: false,
      stripePromise: null,
      showCheckout: false,
      // timeRemaining: 0,
      // isTimerExpired: false,
      isCopied: false,
    };
    // this.localStorageKey = 'timerEndTime';
    // this.timerInterval = null;
    this.childRef = React.createRef();
  }


  componentDidMount(prevProps, prevState, snapshot) {
    // let hash = this.props.location.hash;
    // hash = hash ? hash.replace(/(^#)/g, "") : "";
    let hash = getUrlWord(this.props.match.url, this.props.location.hash);

    this.setState({ hash });

    // if(!this.props.config.id){
    //   if (hash.includes("/")) {
    //     this.props.history.push(hash)
    //   } else if (hash.includes("__CURL_")) {
    //     this.props.history.push('');
    //   } else {
    //     // [hash removal] remove this after hash migration
    //     this.props.history.push('/#'+hash)
    //   }
    // }

  }


  initializeStripe = () => {
    // loadStripe returns a promise, store it in the state
    this.setState({
      stripePromise: loadStripe(STRIPE_PK)
    });
  };

  showCheckoutForm = () => {
    // this.setState({ showCheckout: true });
    // console.log('show-checkout', this.state.showCheckout);
    if (this.childRef.current) {
       this.childRef.current.stopTimer();
    }
    // this.setState({ timeRemaining: 0, isTimerExpired: true });
    // clearInterval(this.timerInterval);
    this.setState(prevState => ({
      showCheckout: !prevState.showCheckout
    }));
  }

  checkAndRouteUrl() {
    let hash = getUrlWord(this.props.match.url, this.props.location.hash);
    console.log('hashssss', hash);
    if (hash.includes("/")) {
      this.props.history.push(hash)
    } else if (hash.includes("__CURL_")) {
      this.props.history.push('');
    } else {
      // [hash removal] remove this after hash migration
      this.props.history.push('/#' + hash)
    }
  }

  componentWillUnmount() {
    if (this.childRef.current) {
       this.childRef.current.stopTimer();
    }
    // if (this.timerInterval) {
    //   clearInterval(this.timerInterval);
    // }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if ((this.props !== prevProps) || (this.state !== prevState)) {
    //   // code
    //   console.log('changedddd props', (this.props !== prevProps));
    //   console.log('changedddd state', (this.state !== prevState));
    // }
    // console.log('curStateeee', this.state);
    // console.log('prevStateeee', prevState);


    if (prevProps && prevProps.config && prevProps.config.id) {
      let idComp = prevProps.config.id;
      const offer = JSON.parse(localStorage.getItem(`${idComp}-offer`));

      if (offer && offer.offer && offer.offer.id && BEIN_CAMPAIGN.includes(idComp)
        && BEIN_SPL_OFFER.includes(offer.offer.id) && !this.timerInterval) {
          // this.initializeTimer();
          // this.timerInterval = setInterval(() => this.tick(), 1000);

          if (this.childRef.current) {
             this.childRef.current.startTimer();
          }
      }

      if (!offer || !offer.offer) {
        this.clearSessionAndRevertToHome(idComp);
      }
    }

    if ((this.props !== prevProps) && prevProps && prevProps.config && prevProps.config.id) {
      let idComp = prevProps.config.id;
      if (!this.state.stripePromise && BEIN_CAMPAIGN.includes(idComp)) {
        console.log('stripe-new');
        this.initializeStripe();
      }
      const idOptin = localStorage.getItem(`${idComp}-idOptin`);
      const isOrderPaid = localStorage.getItem(`${idComp}-orderPaid`);
      if (BEIN_CAMPAIGN.includes(idComp) && idOptin && isOrderPaid) {
        // window.location.href = window.location.href + '/' + idOptin;
        const url = new URL(window.location.href);
        url.search = '';
        window.location.href = url.toString() + '/' + idOptin;
      }
      const allowMultiUserEntry = localStorage.getItem(`${idComp}-allowMultiUserEntry`);
      console.log('allowww', allowMultiUserEntry);

      // enable to redirect on multiple user entry
      // if (allowMultiUserEntry && allowMultiUserEntry == 'true') {
      //   this.checkAndRouteUrl();
      // } else {
      // const idOptin = localStorage.getItem(`${idComp}-idOptin`);
      // const idVote = localStorage.getItem(`${idComp}-idVote`);

        // if (idOptin && offer && offer.offer) {
        //   console.log('offer-selected', offer);
        //   // this.setState({ ...this.state, offer }, () => {
        //   //   console.log('updated', this.state);
        //   // });
        // } else {
        //   // enabling this gets back to home. investigate
        //   this.checkAndRouteUrl();
        //   // this.props.history.push('/#' + prevProps.config.hash);
        // }
      // }

      this.setOfferBg(idComp);

    }
  }

  copyTextToClipboard = async (textToCopy) => {

    try {
      await navigator.clipboard.writeText(textToCopy);
      // Update state on success
      this.setState({ isCopied: true });

      // Reset the "Copied!" message after 2 seconds
      setTimeout(() => {
        this.setState({ isCopied: false });
      }, 2000);

    } catch (err) {
      console.error('Failed to copy text: ', err);
      // Optional: Provide error feedback
      alert('Failed to copy text!');
    }
  }

  openInNewTab = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  setOfferBg = (idComp) => {
    const offer = JSON.parse(localStorage.getItem(`${idComp}-offer`));
    const offerViewed = localStorage.getItem(`${idComp}-offerViewed`);
    const styleTag = document.getElementById('comp-offer-style');
    if (REESES_CAMPAIGN.includes(idComp) && offerViewed && !styleTag && offer && offer.offer) {
      let useStyleBg = 'https://benchvote-media-assets.s3.ap-southeast-2.amazonaws.com/assorted/reeses/reeses-flight-background.png';
      if (offer.offer.type === OFFER_TYPE.DEFAULT) {
        useStyleBg = 'https://benchvote-media-assets.s3.ap-southeast-2.amazonaws.com/assorted/reeses/reeses-fright-background.png';
      }
      const styles = `
          body {
            background: url(${useStyleBg}) no-repeat center center fixed;
          }

          body:after {
            content:"";
            position:fixed;
            height:100vh;
            top:0;
            left:0;
            right:0;
            z-index:-1;
            background: url(${useStyleBg}) center center;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          }
        `;

        var styleSheet = document.createElement("style");
        styleSheet.id = 'comp-offer-style'
        styleSheet.innerText = styles;
        document.head.appendChild(styleSheet);
    }
  }


  handleSubmit = () => {
    const cookies = new Cookies();
    // const idOptin = cookies.get('idOptin');
    // const idVote = cookies.get('idVote');
    const idComp = this.props.config.id;
    const idOptin = localStorage.getItem(`${idComp}-idOptin`);
    const idVote = localStorage.getItem(`${idComp}-idVote`);
    if (this.props.config && idVote && idOptin && this.props.tracking && this.props.tracking.flakeId) {
      const fingerprint = new Fingerprint().get();
      const { flakeId } = this.props.tracking;
      let params = { type: "vote", idVote: idVote, idOptin: idOptin, sessionFlakeId: flakeId, fingerprint: fingerprint }
      this.props.dispatch(trackVote(this.props.config.id, params, this.props.history, this.state.hash, this.props.dispatch));
    }
    const hasEmbedFooter = showEmbedFooter();

    if (this.state.hash.includes("/")) {
      if (hasEmbedFooter) {
        this.props.history.push(this.state.hash + "/claim?embed=true");
      } else {
        this.props.history.push(this.state.hash + "/claim");
      }
    }
    else if (this.state.hash.includes("__CURL_")) {
      if (hasEmbedFooter) {
        this.props.history.push("claim?embed=true");
      } else {
        this.props.history.push("claim");
      }
    } else {
      // [hash removal] remove this after hash migration
      if (hasEmbedFooter) {
        this.props.history.push("/claim/?embed=true#" + this.state.hash);
      } else {
        this.props.history.push("/claim/#" + this.state.hash);
      }
    }

  };

  redeem = (selectedOffer) => {

    // const cookies = new Cookies();
    // const idOptin = cookies.get('idOptin');
    // const idVote = cookies.get('idVote');
    const idComp = this.props.config.id;
    const idOptin = localStorage.getItem(`${idComp}-idOptin`);
    const offerData = JSON.parse(localStorage.getItem(`${idComp}-offer`));

    console.log('offerData-', offerData);
    console.log('idptin-', idOptin);
    console.log('comp-', this.props.config);

    if (this.props && this.props.config && this.props.config.randomizerConfigs
      && this.props.config.randomizerConfigs.redemptionType == 2 && idOptin && offerData && offerData.idVoteRandomizer) {

      // if (this.props.config.id) {
      //   this.props.dispatch(trackSession(this.props.config.id, this.props.dispatch));
      // }

      // if (selectedOffer.type === OFFER_TYPE.OFFER) {
        let payload = {
          id: selectedOffer.id,
          inventory: 10,
          idVoteRandomizer: offerData.idVoteRandomizer
        };
        this.props.dispatch(markCodeRedeemed(idComp, payload, this.props.dispatch));
      // }
    }
    console.log('offer-opened');
    window.open(selectedOffer.offerUrl, "_blank");

  }

  playAgain = () => {
    if (this.props && this.props.config && this.props.config.id) {
      this.clearSessionAndRevertToHome(this.props.config.id);
    }
  }

  handleCallbackAfterSpin = (spinData) => {
    console.log("spin-Data", spinData);
    // Update the name in the component's state
    this.setState({ spinComplete: true });
    if (this.props && this.props.config && this.props.config.id) {
      this.setOfferBg(this.props.config.id);
    }
  };

  triggerCWCampaign = () => {
    console.log('trigger cw campaign', this.props);
    let finalUrl = 'https://receipt.screamforreeses.com';
    // let finalUrl = 'https://www.campaignware.com/reeses/frightorflightreceiptupload';
    // let finalUrl = 'https://loadtest.campaignware.com/sand/cw';
    // finalUrl = 'http://localhost:8002/sand/cw';
    // let finalUrl = 'http://localhost:8002/reeses/frightorflightreceiptupload';
    // const sendData = (data) => {
    //   const targetWindow = window.open(finalUrl);
    //   targetWindow.postMessage(data, finalUrl);
    // };
    let formData = localStorage.getItem(`${this.props.config.id}-optData`);
    // formData = JSON.parse(formData);
    console.log('trigger cw form', formData);
    // sendData({ message: 'Hello from App A!' });

    let message = formData;
    const targetWindow = window.open(finalUrl, 'Child window');
    // targetWindow.addEventListener('load', () => {
      console.log("child-loaded");
      setTimeout(() => {
        targetWindow.postMessage(message, finalUrl);
      }, 2000);
    // });

  }

  triggerVBooster = (vBooster) => {
    console.log('vBooster-props', this.props);

    if (vBooster.ctaLink && vBooster.ctaLink != "") {
      window.open(vBooster.ctaLink, '_blank');
    }

    const idOptin = localStorage.getItem(`${vBooster.idCompetition}-idOptin`);
    if (vBooster.idCompetition && vBooster.id && idOptin) {

      var params = {
        idComp: vBooster.idCompetition,
        idCompVB: vBooster.id,
        idOptin
      }

      this.props.dispatch(
        updateVBPInner(
          vBooster.idCompetition,
          params,
          this.props.dispatch
        )
      );

    }
  }

  clearSessionAndRevertToHome = (idComp) => {
    clearSession(idComp);

    const hasEmbedFooter = showEmbedFooter();

    let finalStateUrl = `/#${this.state.hash}`;

    if (this.state.hash.includes("/")) {
      if (hasEmbedFooter) {
        finalStateUrl = `${this.state.hash}?embed=true`;
      } else {
        finalStateUrl = this.state.hash;
      }
    }
    else if (this.state.hash.includes("__CURL_")) {
      if (hasEmbedFooter) {
        finalStateUrl = `?embed=true`;
      } else {
        finalStateUrl = "";
      }
    } else {
      // [hash removal] remove this after hash migration
      if (hasEmbedFooter) {
        finalStateUrl = `/?embed=true#${this.state.hash}`;
      }
    }
    this.props.history.push(finalStateUrl);
  }


  // handleTimerExpired = (data) => {
  //   console.log('timer-epired', data);
  //   this.setState({ timerExpired: data });
  // };

  render() {
    let { config } = this.props;
    let voteConts = "";

    const hasEmbedFooter = showEmbedFooter();

    if (config && Object.keys(config).length > 0) {

      // setTimeout(() => {
      //   this.setState({ showBtn: true });
      // }, this.state.delayTime);

      // const question = config.offers.find(
      //   val => val.type === "default_offer"
      // );

      // const data = [
      //     { "label": "OFFER 1", "value": 1, "weight": 1, "question": "Congratulations on OFFER 1" }, // padding
      //     { "label": "OFFER 2", "value": 2, "weight": 3, "question": "Congratulations on OFFER 2" }, //font-family
      //     { "label": "OFFER 3", "value": 3, "weight": 1, "question": "Congratulations on OFFER 3" }, //color
      //     { "label": "OFFER 4", "value": 4, "weight": 2, "question": "Congratulations on OFFER 4" }, //font-weight
      //     { "label": "OFFER 5", "value": 5, "weight": 3, "question": "Congratulations on OFFER 5" }, //font-size
      //     { "label": "OFFER 6", "value": 6, "weight": 0, "question": "Congratulations on OFFER 6" }, //background-color
      //     { "label": "OFFER 7", "value": 7, "question": "Congratulations on OFFER 7" }, //nesting
      //     { "label": "OFFER 8", "value": 8, "question": "Congratulations on OFFER 8" }, //bottom
      //     { "label": "OFFER 9", "value": 9, "question": "Congratulations on OFFER 9" }, //sans-serif
      //     { "label": "OFFER 10", "value": 10, "question": "Congratulations on OFFER 10" }
      // ];

      const data = config.offers;
      console.log('data-set', data);

      let offerData = JSON.parse(localStorage.getItem(`${config.id}-offer`));
      console.log('offer-set', offerData);

      let selectedOffer = {};

      if (offerData) {
        selectedOffer = offerData.offer;
      }

      let selec = -1;
      data.forEach((offer, key) => {
        if (offerData && offerData.offer && offer.id === offerData.offer.id) {
          selec = key;
        }
      });

      console.log('selec', selec);

      let code = false;
      if (selectedOffer.codeType == 1) {
        code = selectedOffer.code;
      } else {
        code = selectedOffer.codeUnique;
      }

      let offerViewed = localStorage.getItem(`${config.id}-offerViewed`);

      if (offerViewed && !isSessionActive(config.id)) {
        this.clearSessionAndRevertToHome(config.id);
      }

      const { stripePromise } = this.state;

      const { showCheckout } = this.state;

      voteConts = (
        <React.Fragment>
          {/* <div className={'intro'}>
            <div>
              {config.logoBg && !config.logoFullscreen ? (
                <div className={'logos-cont'}>
                  <img src={config.logoBg.file} className={'logo-image'} />
                </div>
              ) : null}
            </div>
          </div>*/}

          <SpinWheel data={data} selection={selec} selectedOffer={selectedOffer} compData={config} offerData={offerData}
          code={code} offerCallback={this.handleCallbackAfterSpin} showCheckout={showCheckout} />

          {/* <br />*/}

          {offerViewed && config.randomizerConfigs.isOfflineRedemption !== 1
            && config.randomizerConfigs.isRedemptionUrlEnabled === 1
            && selectedOffer.offerUrl && selectedOffer.offerUrl != '' ? (
            <div className="m-auto w-100">
              <div
                className={"primary submit-optin cursor_pointer mb-5" + (hasEmbedFooter ? "" : " no-embed")}
                onClick={() => this.redeem(selectedOffer)}
                style={{
                  backgroundColor: config ? config.buttonColor : "",
                  color: config ? config.secondaryColor : "",
                  display: "block"
                }}
              >
                Redeem
              </div>
            </div>
          ) : null}

          {BEIN_CAMPAIGN.includes(config.id) && offerViewed
            ?
            (BEIN_SPL_OFFER.includes(selectedOffer.id)
              ? (showCheckout
                ? <div>
                  <div style={{ color: config.primaryColor }} className="checkout-form-wrapper">
                    <Checkout stripePromise={stripePromise} compData={config} dCode={code}/>
                    {/* <Elements stripe={stripePromise}>
                      <CheckoutForm config={config} />
                    </Elements>*/}
                    <div>
                      By submitting payment, your card will be charged $79.99, and you will then be provided with a voucher code that will give you 12-months of beIN SPORTS CONNECT.
                    </div>
                    <div>
                      You will be given instructions on how to redeem this.
                    </div>
                  </div>
                </div>
                : <div className="checkout-block">
                  <TimerView ref={this.childRef} selectedOffer={selectedOffer} />
                  {/* <div className={`checkout-timer ${timerColor}`}>
                    <div>ONLY 5 CODES LEFT AT THIS PRICE</div>
                    {timeRemaining > 0 ? <div><img src={timer_image} /> {this.formatTime(timeRemaining)} REMAINING</div> : ''}
                  </div>*/}
                  <div>SECURE YOUR DISCOUNT NOW</div>
                  <div
                    className={"primary submit-optin cursor_pointer green-btn"}
                    onClick={this.showCheckoutForm}
                    style={{
                      display: "block",
                    }}
                  >
                    CHECKOUT
                  </div>
                  <div>
                    By submitting payment, your card will be charged $79.99, and you will then be provided with a voucher code that will give you 12-months of beIN SPORTS CONNECT.
                  </div>
                  <div>
                    You will be given instructions on how to redeem this.
                  </div>
                </div>)
              : (selectedOffer && selectedOffer.codeUnique && selectedOffer.codeUnique !== '')
                ? (
                  <div className="overflow-auto thanks-offer">
                    <div className="col-sm-12">
                      <div className="thanks-lg">Thanks for purchasing.</div>
                      <div className="thanks-lg">Your unique code is:</div>
                      <div className="thanks-offer-code">{selectedOffer.codeUnique} <img onClick={() => this.copyTextToClipboard(selectedOffer.codeUnique)} src={content_copy}/></div>
                      {this.state.isCopied ? <div>copied</div> : ''}
                      <p>To redeem your code, simply follow these instructions:</p>

                      <div
                        className={"primary submit-optin cursor_pointer green-btn"}
                        onClick={() => this.openInNewTab('https://cpnl.ink/782762s2')}
                        style={{
                          display: "block",
                        }}
                      >
                        READ INSTRUCTIONS
                      </div>
                      <p>
                        (We’ve also emailed the unique code and instructions to
                        you.)</p>
                      <p>Need more help? Email us at <a href="mailto:help@campaignware.com">help@campaignware.com</a>
                      </p>
                    </div>
                  </div>)
                : '')
            : ''}

          {BEIN_CAMPAIGN.includes(config.id) && offerViewed && selectedOffer && selectedOffer.type === 'default_offer' ?
            <div
              className={"primary submit-optin cursor_pointer mt-5"}
              onClick={() => this.openInNewTab('https://cpnl.ink/4c3c0d9err')}
              style={{
                display: "block",
                backgroundColor: config.buttonColor,
                color: config.secondaryColor
              }}
            >
              TAKE ME TO THE OFFER
            </div> : ''
          }

          {REESES_CAMPAIGN.includes(config.id) && offerViewed && selectedOffer && selectedOffer.type !== 'default_offer'
            ? <div className="w-100"style={{
                marginTop: '-78px'
              }}>
              <div className="col-sm-12">
                <div style={{ color: config.primaryColor }} className="cust-redeem-section">
                    <p>Simply upload your receipt now to redeem your prize!</p>
                    <div
                      className={"primary submit-optin cursor-pointer" + (hasEmbedFooter ? "" : " no-embed")}
                      style={{
                        backgroundColor: config.buttonColor,
                        color: config.secondaryColor
                      }}
                      onClick={this.triggerCWCampaign}
                    >
                      REDEEM NOW
                    </div>
                </div>
              </div>
            </div>

            : null}

          {REESES_CAMPAIGN.includes(config.id) && offerViewed
            ? <div style={{ color: config.primaryColor }} className="bold recees-winner-info">
              Winner to be drawn and announced at the end of the promotional period
            </div>
            : null}

          {offerViewed && config.isViralSharingEnabled && config.viralBoosters
            && config.viralBoosters.length

            ? <div className="w-100">
              <div className="col-sm-12">
                <div className="v-booster-section">
                  {/* {this.props.competition.vBoosterTotalPoints > 0
                    ? <p class="points-so-far text-center"
                      style={{ color: config ? config.primaryColor : '' }}>
                      YOU'VE GOT {this.props.competition.vBoosterTotalPoints} ENTRIES SO FAR...</p>
                    : null
                  } */}
                  {config.drawCopy && config.drawCopy != '' ? <div className="v-b-info">
                    <span
                      style={{
                        color: config.primaryColor ? config.primaryColor : '#FFFFFF'
                      }}
                      dangerouslySetInnerHTML={{ __html: config.drawCopy }}>
                    </span>
                  </div> : ''}
                  {config.viralBoosters.map((vb, vbIndex) =>
                    <div className="v-booster" style={{
                      backgroundColor: vb.buttonColor ? vb.buttonColor : '#808080',
                      color: vb.textColor ? vb.textColor : '#FFFFFF',
                    }} onClick={() => this.triggerVBooster(vb)}
                      key={vbIndex}>
                      {vb.image ? <img src={vb.image.file} /> : ''}
                      <span className="v-b-text">{vb.ctaText}</span>
                      {/* {this.props.competition && this.props.competition.clickedBoosters.length
                        && this.props.competition.clickedBoosters.includes(vb.id)
                        ? <span className="v-b-p-added">
                          <img src="https://benchvote-media-assets.s3.ap-southeast-2.amazonaws.com/common-images/icons/tick_green.png" />
                        </span>
                        : null} */}
                    </div>
                  )}
                </div>

              </div>
            </div>

            : null}


            {offerViewed && config.allowMultiUserEntry ? (
              <div className="m-auto w-100">
                <div
                  className={"primary submit-optin cursor_pointer play-again mb-5" + (hasEmbedFooter ? "" : " no-embed")}
                  onClick={() => this.playAgain()}
                  style={{
                    backgroundColor: config ? config.buttonColor : "",
                    color: config ? config.secondaryColor : "",
                    display: "block"
                  }}
                >
                  PLAY AGAIN
                </div>
              </div>
            ) : null}

          <Footer />
        </React.Fragment>
      );

      if (document.getElementById("container-spin") && !localStorage.getItem(`${config.id}-offerViewed`)
        && selectedOffer) {
        document.getElementById("container-spin").dispatchEvent(new Event('click'));
      }
    }

    let noBorderRadius = (config && config.defaultShape === 2);

    return <div className={"offer " + (noBorderRadius ? 'no-border-radius' : '')}>{voteConts}</div>;
  }
}

const mapStateToProps = (state, ownProps) => {

  console.log(state);
  return {
    ...ownProps,
    config: state.default.data.config,
    locale: state.default.locale,
    offer: state.default.data.offer,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Offer);
